import { getSorterByField } from '../../../atoms/columns/utils/getSorterByField'
import { getProject } from '../../../atoms/project/project'
import { getSchedulerPreferences } from '../../../utils/getSchedulerPreferences'

export function setInitialSchedulerSorting() {
  const project = getProject()
  const preferences = getSchedulerPreferences()
  const sorter = preferences.sorters[0]
  if (!sorter) return

  project.resourceStore.sort({
    ascending: sorter.ascending,
    field: sorter.field.replace('dynamic-loads-', 'loads.'),
    fn: getSorterByField(sorter.field),
  })
}
